import React from "react";
import PropTypes from "prop-types";
import styles from "./Button.module.scss";

function Button({ children, className = "", onClick, disabled = false, type = "button", ...rest }) {
    return (
        <button type={type} className={`${styles.button} ${className}`} onClick={onClick} disabled={disabled} {...rest} >
            {children}
        </button>
    );
}

Button.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    type: PropTypes.oneOf(["button", "submit", "reset"]),
};

export default React.memo(Button);